module.exports = __webpack_public_path__ + "img/tanzania_impact.adde8723.jpg";